import dayjs, { type Dayjs } from "dayjs";

/** Granularidade do filtro: um dia ou o mês inteiro. */
export type DateFilterMode = "day" | "month";

/** Formato usado nas buscas FHIR (`date=ge` / `date=le`). */
export const QUERY_DATE_FORMAT = "YYYY-MM-DD";

/** Período `{ startDate, endDate }` (YYYY-MM-DD) do filtro. */
export function dateRangeFor(date: Dayjs, mode: DateFilterMode) {
  const start = mode === "day" ? date.startOf("day") : date.startOf("month");
  const end = mode === "day" ? date.endOf("day") : date.endOf("month");
  return {
    startDate: start.format(QUERY_DATE_FORMAT),
    endDate: end.format(QUERY_DATE_FORMAT),
  };
}

/** Os 7 dias (segunda a domingo) da semana da data. */
export function weekDaysOf(date: Dayjs): Dayjs[] {
  const daysSinceMonday = (date.day() + 6) % 7;
  const monday = date.startOf("day").subtract(daysSinceMonday, "day");
  return Array.from({ length: 7 }, (_, dayIndex) => monday.add(dayIndex, "day"));
}

/** Um instante está dentro do período do filtro? (para filtrar listas já carregadas) */
export function isWithinDateFilter(
  value: string | undefined,
  date: Dayjs,
  mode: DateFilterMode,
): boolean {
  if (!value) return false;
  const instant = dayjs(value);
  return instant.isValid() && instant.isSame(date, mode);
}
